import styled from 'styled-components'
import { OUTLINE_COLOR, FONT_BASE_COLOR, GREY_BACKGROUND } from '@CSSVars/colors'
import Flex from 'Components/Flex'

export const _SideLinkContent = styled(Flex)`
  height: 64px;
  padding-left: 30px;
  border-bottom: 1px solid ${OUTLINE_COLOR};
  ${({ active }) => (active && `background: ${GREY_BACKGROUND};`)};
  .previewIcon {
    svg {
      fill: ${FONT_BASE_COLOR};
      .favouriteSt2 {
         fill: ${FONT_BASE_COLOR};
      }
    }
  }
  .previewCopy {
    color: ${FONT_BASE_COLOR};
    font-size: 18px;
    line-height: 22px;
    padding-left: 10px;
  }
`
